import { Dispatch } from 'redux';

import CheckoutActionTypes, { CHECKOUT_APPLY_PROMO_FAIL } from '../Checkout.types';
import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import { PROMO_URL, REMOVE_PROMO_URL } from '../../constants/apis.constant';
import { updateCart } from 'pages/Cart/redux/actions';
import { IAppState } from 'config/redux/reducers';
import { getCartId } from 'pages/Cart/helpers/url.helpers';
import { promoErrorHandler } from 'pages/Checkout/helpers/promoErrorHandler';
import { getSelectedCardBin } from 'pages/Checkout/components/Payment/helpers/payment.helpers';
import { createGrowthBookInstance, smartlook } from '@mafc/appshell';
import { smartlookErrorLabels } from '@mafc/common';
import { APPLY_PROMO_CODE_API_TIMEOUT } from 'pages/Checkout/constants/checkout.constant';
import { appliedCouponApiSuccess } from 'pages/Checkout/components/AvailablePromotions/redux/AvailablePromotions.action';

const promoFail = (
  dispatch: Dispatch,
  payload: { error: string; errorPromoCode: string; t: any }
) => {
  dispatch({
    type: CHECKOUT_APPLY_PROMO_FAIL,
    payload,
  });
};

const setBrazePromoCodeAndType = (code?: string, type?: string) => {
  const brazeStringify = JSON.stringify({
    promo_code: code || '',
    promo_type: type || '',
  });

  localStorage.setItem('brazePurchaseCompleteData', brazeStringify);
};

export const extractErrorProps = (errObj: { [K: string]: any }) => {
  const { statusCode = '', errorCode = '', message = '', detail = '' } =
    ((errObj.response || {}).data || {}).meta || {};
  return { statusCode, errorCode, message, detail };
};

export const applyPromo = (voucherId: string, t: any, successCallback?: () => void) => (
  dispatch: Dispatch,
  getState: () => IAppState
) => {
  const store = getState();
  const {
    appConfig: { areaCode, growthBook },
    checkout: { payment: { paymentDetails = {} } = {} } = {},
  } = store;
  const binCode = getSelectedCardBin(paymentDetails);
  const growthbook = createGrowthBookInstance(
    {
      ...growthBook,
    },
    store
  );
  const stcl = growthbook.feature('common.store_close_services.enabled').on || false;
  dispatch({
    type: CheckoutActionTypes.CHECKOUT_APPLY_PROMO,
    payload: {
      method: EApiMiddlewareMethod.PUT,
      apiVersion: 1,
      url: PROMO_URL,
      timeout: APPLY_PROMO_CODE_API_TIMEOUT,
      params: {
        cartId: getCartId(getState()),
        areacode: areaCode,
        binCode,
        stcl,
      },
      data: {
        voucherId,
      },
      onSuccess: (data: { [key: string]: any }) => {
        const brazePromoType = voucherId.split('-')[0] === 'PROMO' ? 'referral' : '';

        setBrazePromoCodeAndType(voucherId, brazePromoType);
        updateCart(dispatch, data);
        dispatch(appliedCouponApiSuccess(true));
        if (successCallback) {
          successCallback();
        }
      },
      onFailure: (genericErr: any, error: any) => {
        const { errorCode, message, detail } = extractErrorProps(error);
        const errorMsg = promoErrorHandler(message || errorCode || detail, t);
        smartlook.track(smartlookErrorLabels.promoCodeFailure);
        promoFail(dispatch, { error: errorMsg, t, errorPromoCode: voucherId });
      },
    },
  });
};

export const removePromo = (voucherId: string, t: any, successCallback?: () => void) => (
  dispatch: Dispatch,
  getState: () => IAppState
) => {
  const store = getState();
  const {
    appConfig: { areaCode, growthBook },
  } = store;
  const growthbook = createGrowthBookInstance(
    {
      ...growthBook,
    },
    store
  );
  const stcl = growthbook.feature('common.store_close_services.enabled').on || false;
  dispatch({
    type: CheckoutActionTypes.CHECKOUT_REMOVE_PROMO,
    payload: {
      method: EApiMiddlewareMethod.DELETE,
      apiVersion: 1,
      url: REMOVE_PROMO_URL,
      data: {
        voucherId,
      },
      params: {
        areacode: areaCode,
        cartId: getCartId(getState()),
        stcl,
      },
      onSuccess: (data: { [key: string]: any }) => {
        setBrazePromoCodeAndType();
        updateCart(dispatch, data);
        if (successCallback) {
          successCallback();
        }
      },
      onFailure: (error: any) => promoFail(dispatch, { error, t, errorPromoCode: voucherId }),
    },
  });
};

export const resetPromo = () => {
  return {
    type: CheckoutActionTypes.CHECKOUT_RESET_PROMO,
  };
};
